module.exports = __webpack_public_path__ + "static/img/xiazailuyin.713cc13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/xiazailuyin.png
// module id = uO1G
// module chunks = 24